var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        title: _vm.coreString("enterPinPlaceholder"),
        submitText: _vm.coreString("continueAction"),
        cancelText: _vm.coreString("cancelAction"),
      },
      on: {
        submit: _vm.submit,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c("KTextbox", {
        ref: "pinFocus",
        attrs: {
          input: "number",
          type: "password",
          label: _vm.$tr("pinPlaceholder"),
          maxlength: 4,
          invalid: _vm.showErrorText,
          invalidText: _vm.pinError,
          showInvalidText: _vm.showErrorText,
        },
        model: {
          value: _vm.pin,
          callback: function ($$v) {
            _vm.pin = $$v
          },
          expression: "pin",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }